import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/github";
import { Pre, Line, LineNo, LineContent } from "./styles";

// C# Sample Code for Post Journal Entry Batch Light
const csharp = `var client = new HttpClient();
var request = new HttpRequestMessage(HttpMethod.Post, "baseurl/API/JournalEntry/PostJournalEntryBatch");
request.Headers.Add("Authorization", "Bearer Bearer abc");
var content = new StringContent("[\r\n  {\r\n    \"backofficeAccountNumber\": \"X5ud-usmM-988425-PX\",\r\n    \"transactionType\": \"Deposit\",\r\n    \"amount\": 0.01,\r\n    \"externalId\": \"string\",\r\n    \"tradeDate\": \"2025-05-15T06:32:03.675Z\"\r\n  },\r\n  {\r\n    \"backofficeAccountNumber\": \"X5ud-usmM-988425-PX\",\r\n    \"transactionType\": \"Withdrawal\",\r\n    \"amount\": 0.01,\r\n    \"externalId\": \"string\",\r\n    \"tradeDate\": \"2025-05-15T06:32:03.675Z\"\r\n  }\r\n]", null, "application/json");
request.Content = content;
var response = await client.SendAsync(request);
response.EnsureSuccessStatusCode();
Console.WriteLine(await response.Content.ReadAsStringAsync());
`;

function HTTPPostJournalEntryBatchCsharp() {
  return (
    <Highlight {...defaultProps} theme={theme} code={csharp} language="csharp">
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <Pre className={className} style={style}>
          {tokens.map((line, i) => (
            <Line key={i} {...getLineProps({ line, key: i })}>
              <LineNo>{i + 1}</LineNo>
              <LineContent>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </LineContent>
            </Line>
          ))}
        </Pre>
      )}
    </Highlight>
  );
}
export default HTTPPostJournalEntryBatchCsharp;
